import { render, staticRenderFns } from "./WhatIfsTableCountry.vue?vue&type=template&id=6d36b580&"
import script from "./WhatIfsTableCountry.vue?vue&type=script&lang=js&"
export * from "./WhatIfsTableCountry.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfsTableCountry.vue?vue&type=style&index=0&id=6d36b580&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports